import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, Typography, DialogActions, Button} from '@material-ui/core';

import Context from 'utils/Context';
import BookButton from 'components/BookButton';
import CartoucheSeance from 'components/CartoucheSeance';
import Paiement from 'components/Paiement/Paiement';

const Ticketing = ({onSuccess, seance}) => {
  const {appState, modele, methods, ed} = useContext(Context);
  const {t} = useTranslation();

  const {mes_seances: myShows} = appState.user;
  const seanceIsInMesSeances = myShows && myShows.some(s => s.seance_id === seance.seance_id);
  if (seance.prix) {
    return <Paiement open={true} onClose={() => {}} seance={seance} checkOnly onSuccess={onSuccess} keepOpen />;
  }
  return (
    <Dialog open={true} scroll="body" className="my-dialog">
      <DialogContent>
        <CartoucheSeance hideBtns seance={seance} appState={appState} modele={modele} />
        <Typography variant="h6" component="h2" noWrap>
          {t('gratuit')}
        </Typography>
      </DialogContent>
      <DialogActions>
        {seanceIsInMesSeances && (
          <Button
            disabled={seance.ended}
            className="seance-btn"
            color="primary"
            size="small"
            variant="contained"
            onClick={onSuccess}
          >
            {t('acceder-a-la-seance')}
          </Button>
        )}
        {!seanceIsInMesSeances && <BookButton appState={appState} methods={methods} ed={ed} seance={seance} />}
      </DialogActions>
    </Dialog>
  );
};

export default Ticketing;
